export const ActionTypes = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",

  VERIFICATION_REQUEST: "VERIFICATION_REQUEST",
  VERIFICATION_SUCCESS: "VERIFICATION_SUCCESS",
  VERIFICATION_FAILURE: "VERIFICATION_FAILURE",

  RESET_PASSWORD_REQUEST: "RESET_PASSWORD_REQUEST",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_FAILURE: "RESET_PASSWORD_FAILURE",

  RESET_TOKEN_VERIFICATION_REQUEST: "RESET_TOKEN_VERIFICATION_REQUEST",
  RESET_TOKEN_VERIFICATION_SUCCESS: "RESET_TOKEN_VERIFICATION_SUCCESS",
  RESET_TOKEN_VERIFICATION_FAILURE: "RESET_TOKEN_VERIFICATION_FAILURE",

  UPDATE_PASSWORD_REQUEST: "UPDATE_PASSWORD_REQUEST",
  UPDATE_PASSWORD_SUCCESS: "UPDATE_PASSWORD_SUCCESS",
  UPDATE_PASSWORD_FAILURE: "UPDATE_PASSWORD_FAILURE",

  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "LOGOUT_FAILURE",

  CHANGE_LOCALE: "CHANGE_LOCALE",

  REGISTER_TEACHER_REQUEST: "REGISTER_TEACHER_REQUEST",
  REGISTER_TEACHER_SUCCESS: "REGISTER_TEACHER_SUCCESS",
  REGISTER_TEACHER_FAILURE: "REGISTER_TEACHER_FAILURE",

  REGISTER_PARENT_REQUEST: "REGISTER_PARENT_REQUEST",
  REGISTER_PARENT_SUCCESS: "REGISTER_PARENT_SUCCESS",
  REGISTER_PARENT_FAILURE: "REGISTER_PARENT_FAILURE",

  UPDATE_PROFILE_REQUEST: "UPDATE_PROFILE_REQUEST",
  UPDATE_PROFILE_FAILURE: "UPDATE_PROFILE_FAILURE",
  UPDATE_PROFILE_SUCCESS: "UPDATE_PROFILE_SUCCESS",

  STATE_REQUEST: "STATE_REQUEST",
  STATE_FETCHING_SUCCESS: "STATE_FETCHING_SUCCESS",
  STATE_FETCHING_FAILURE: "STATE_FETCHING_FAILURE",

  /* --- PARENT --- */

  CHILDREN_REQUEST: "CHILDREN_REQUEST",
  CHILDREN_RECEIVING_SUCCESS: "CHILDREN_RECEIVING_SUCCESS",
  CHILDREN_RECEIVING_FAILURE: "CHILDREN_RECEIVING_FAILURE",

  ADD_CHILD_REQUEST: "ADD_CHILD_REQUEST",
  ADD_CHILD_SUCCESS: "ADD_CHILD_SUCCESS",
  ADD_CHILD_FAILURE: "ADD_CHILD_FAILURE",

  UPDATE_CHILD_REQUEST: "UPDATE_CHILD_REQUEST",
  UPDATE_CHILD_SUCCESS: "UPDATE_CHILD_SUCCESS",
  UPDATE_CHILD_FAILURE: "UPDATE_CHILD_FAILURE",

  DESTROY_CHILD_REQUEST: "DESTROY_CHILD_REQUEST",
  DESTROY_CHILD_SUCCESS: "DESTROY_CHILD_SUCCESS",
  DESTROY_CHILD_FAILURE: "DESTROY_CHILD_FAILURE",

  CHILDREN_DIPLOMAS_REQUEST: "CHILDREN_DIPLOMAS_REQUEST",
  CHILDREN_DIPLOMAS_RECEIVING_SUCCESS: "CHILDREN_DIPLOMAS_RECEIVING_SUCCESS",
  CHILDREN_DIPLOMAS_RECEIVING_FAILURE: "CHILDREN_DIPLOMAS_RECEIVING_FAILURE",

  PARENT_PRETEND_REQUEST: "PARENT_PRETEND_REQUEST",
  PARENT_PRETEND_SUCCESS: "PARENT_PRETEND_SUCCESS",
  PARENT_PRETEND_FAILURE: "PARENT_PRETEND_FAILURE",

  CHILDREN_STATISTICS_REQUEST: "CHILDREN_STATISTICS_REQUEST",
  CHILDREN_STATISTICS_RECEIVING_SUCCESS: "CHILDREN_STATISTICS_RECEIVING_SUCCESS",
  CHILDREN_STATISTICS_RECEIVING_FAILURE: "CHILDREN_STATISTICS_RECEIVING_FAILURE",

  /* --- TEACHER --- */

  CLASSES_REQUEST: "CLASSES_REQUEST",
  CLASSES_RECEIVING_SUCCESS: "CLASSES_RECEIVING_SUCCESS",
  CLASSES_RECEIVING_FAILURE: "CLASSES_RECEIVING_FAILURE",

  ADD_LEARNER_REQUEST: "ADD_LEARNER_REQUEST",
  ADD_LEARNER_SUCCESS: "ADD_LEARNER_SUCCESS",
  ADD_LEARNER_FAILURE: "ADD_LEARNER_FAILURE",

  UPDATE_LEARNER_REQUEST: "UPDATE_LEARNER_REQUEST",
  UPDATE_LEARNER_SUCCESS: "UPDATE_LEARNER_SUCCESS",
  UPDATE_LEARNER_FAILURE: "UPDATE_LEARNER_FAILURE",

  DESTROY_LEARNER_REQUEST: "DESTROY_LEARNER_REQUEST",
  DESTROY_LEARNER_SUCCESS: "DESTROY_LEARNER_SUCCESS",
  DESTROY_LEARNER_FAILURE: "DESTROY_LEARNER_FAILURE",

  CLASS_STATISTICS_REQUEST: "CLASS_STATISTICS_REQUEST",
  CLASS_STATISTICS_RECEIVING_SUCCESS: "CLASS_STATISTICS_RECEIVING_SUCCESS",
  CLASSES_RECEIVING_FAILURE: "CLASSES_RECEIVING_FAILURE",

  CREATE_CLASS_REQUEST: "CREATE_CLASS_REQUEST",
  CREATE_CLASS_FAILURE: "CREATE_CLASS_FAILURE",
  CREATE_CLASS_SUCCESS: "CREATE_CLASS_SUCCESS",

  CLASS_DIPLOMAS_REQUEST: "CLASS_DIPLOMAS_REQUEST",
  CLASS_DIPLOMAS_RECEIVING_SUCCESS: "CLASS_DIPLOMAS_RECEIVING_SUCCESS",
  CLASS_DIPLOMAS_RECEIVING_FAILURE: "CLASS_DIPLOMAS_RECEIVING_FAILURE",

  /* --- LEARNER --- */

  TASKS_REQUEST: "TASKS_REQUEST",
  TASKS_RECEIVING_SUCCESS: "TASKS_RECEIVING_SUCCESS",
  TASKS_RECEIVING_FAILURE: "TASKS_RECEIVING_FAILURE",

  TASK_RATE_REQUEST: "TASK_RATE_REQUEST",
  TASK_RATE_SUCCESS: "TASK_RATE_SUCCESS",
  TASK_RATE_FAILURE: "TASK_RATE_FAILURE",
  TASKS_INVALIDATION: "TASKS_INVALIDATION",

  PARTICIPATE_REQUEST: "PARTICIPATE_REQUEST",
  PARTICIPATE_SUCCESS: "PARTICIPATE_SUCCESS",
  PARTICIPATE_FAILURE: "PARTICIPATE_FAILURE",

  FINISH_OLYMPIAD_REQUEST: "FINISH_OLYMPIAD_REQUEST",
  FINISH_OLYMPIAD_SUCCESS: "FINISH_OLYMPIAD_SUCCESS",
  FINISH_OLYMPIAD_FAILURE: "FINISH_OLYMPIAD_FAILURE",

  RESTART_OLYMPIAD_REQUEST: "RESTART_OLYMPIAD_REQUEST",
  RESTART_OLYMPIAD_SUCCESS: "RESTART_OLYMPIAD_SUCCESS",
  RESTART_OLYMPIAD_FAILURE: "RESTART_OLYMPIAD_FAILURE",

  /* --- PRIVATE --- */

  _STUDENT_ACTION_REQUEST: "_STUDENT_ACTION_REQUEST",
  _STUDENT_ACTION_SUCCESS: "_STUDENT_ACTION_SUCCESS",
  _STUDENT_ACTION_FAILURE: "_STUDENT_ACTION_FAILURE",

  _CLASS_ACTION_REQUEST: "_CLASS_ACTION_REQUEST",
  _CLASS_ACTION_SUCCESS: "_CLASS_ACTION_SUCCESS",
  _CLASS_ACTION_FAILURE: "_CLASS_ACTION_FAILURE",

  /* --- API --- */

  API_ERROR: "API_ERROR",
  ACCESS_DENIED: "ACCESS_DENIED",
  NETWORK_ERROR: "NETWORK_ERROR",
  CLEAR_API_ERRORS: "CLEAR_API_ERRORS"
}

export const APIAction = 'API'

export const Score = { min: 0, max: 10 }

export default {
  APIEndpoint: `/api`,
  APIAction: APIAction,
  Score: Score,
  ActionTypes: ActionTypes
}
